import { Inject, Injectable, NgZone, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, catchError } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { NotificationService } from './notification.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private _http = inject(HttpClient);
  private dialogRef = inject(MatDialog);
  private notificationService = inject(NotificationService);
  private zone = inject(NgZone);
  private router = inject(Router);
  private translateService = inject(TranslateService);
  public errorHandlerService = inject(ErrorHandlerService);

  validationOnlyHeader = new HttpHeaders().set('x-validate-only', '');


  constructor(@Inject('API_BASE_URL') private _baseUrl: string) { }

  get<T>(resource: string, params: any = {}, options: any = {}): Observable<T> {
    return this._http
      .get<T>(this._baseUrl + '/' + resource, { params, ...options })
      .pipe(catchError(err => this.errorHandlerService.handleError(err)));
  }

  post<T>(resource: string, params?: T, options: any = {}): Observable<T> {
    return this._http
      .post<T>(this._baseUrl + '/' + resource, params, options)
      .pipe(catchError(err => this.errorHandlerService.handleError(err)));
  }

  put<T>(resource: string, params?: T, options: any = {}): Observable<T> {
    return this._http
      .put<T>(this._baseUrl + '/' + resource, params, options)
      .pipe(catchError(err => this.errorHandlerService.handleError(err)));
  }

  patch<T>(resource: string, params?: T, options: any = {}): Observable<T> {
    return this._http
      .patch<T>(this._baseUrl + '/' + resource, params, options)
      .pipe(catchError(err => this.errorHandlerService.handleError(err)));
  }

  delete<T>(resource: string, params?: object): Observable<T> {
    return this._http
      .delete<T>(this._baseUrl + '/' + resource, params)
      .pipe(catchError(err => this.errorHandlerService.handleError(err)));
  }



}
